import { FC } from "react";
import classNames from "classnames";
import { SkeletonProps } from "./interface";

import styles from "./Skeleton.module.scss";

export const Skeleton: FC<SkeletonProps> = ({ className }) => {
  return (
    <div
      className={classNames(styles.Skeleton, {
        [className]: className,
      })}
    ></div>
  );
};
